import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ICheckDuplicateAccountPayload,
  ICheckDuplicateUserPayload,
  ISignup,
  ISignupConfirmPhone,
  ISignupPhone,
  ISignupUser,
  ICheckVatPayload,
} from '@app/models/signup';

@Injectable({
  providedIn: 'root'
})

export class InvitationPublicCloudCreatePasswodService {

  constructor(
    private http: HttpClient,
  ) { }


  generatePassword(password: string): Promise<any> {
    return this.http
      .post<any>(`/invitation/public-cloud/accept`, { password })
      .toPromise();
  }

}
